import React from 'react';
import {
  Box, Button, Typography,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import video from '../../../resources/video.mp4';

const Project = () => {
  const navigate = useNavigate();

  const handleEnroll = () => {
    navigate('/apply_now');
  };

  return (
    <Box id="projects">
      <Box sx={{
        width: '90%', bgcolor: 'transparent', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center', margin: '70px auto',
      }}
      >
        <Box sx={{ width: { xs: '80%', sm: '56%' } }}>
          <video
            style={{
              width: '400px',
              height: '500px',
            }}
            id="video"
            autoPlay
            loop
            muted
          >
            <source src={video} type="video/mp4" />
          </video>
        </Box>
        <Box sx={{ width: { xs: '80%', sm: '40%' } }}>
          <Typography sx={{ color: '#71E5FF', lineHeight: 'auto', padding: '20px 0' }}>Request Early Access to Get Started</Typography>
          <Typography sx={{
            background: 'linear-gradient(to right, #F49867, #AE67FA)', textFillColor: 'transparent', backgroundClip: 'text', fontSize: '30px', fontWeight: '600', lineHeight: '40px',
          }}
          >
            Students Learn   by Doing
          </Typography>
          <Typography sx={{ color: '#81AFDD', lineHeight: 'auto', padding: '20px 0' }}>When kids make something, they get excited! Our syllabus is divided into projects; each eventually becomes a product kids can share with family and friends. Why project-based learning? Because as students focus on creating a game they can show to their friends, they’re learning other skills, like calculating angles and the distance between players. That&apos;s why most of our class time is dedicated to projects rather than lessons.</Typography>
        </Box>
      </Box>
      <Box
        id="pricing"
        sx={{
          width: '100%', background: 'linear-gradient(to right, #AE67FA, #F49867)', padding: '40px', borderRadius: '5px', margin: '100px 0', display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'center', alignItems: { xs: 'start', sm: 'center' },
        }}
      >
        <Box sx={{ width: '70%' }}>
          <Typography sx={{ color: '#000', fontWeight: '400', padding: '10px 0' }}>We Enroll A New Cohort On The 15th of Each Month</Typography>
          <Typography sx={{ color: '#000', fontWeight: '400', fontSize: '20px' }}>Tuition for all our programs is $45 billed monthly</Typography>
        </Box>
        <Box sx={{ width: '20%' }}>
          <Button
            onClick={handleEnroll}
            variant="contained"
            sx={{
              backgroundColor: '#000', color: '#fff', '&:hover': { background: '#fff', color: '#000' }, padding: '8px 35px', borderRadius: '20px',
            }}
          >
            ENROLL NOW
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default Project;
